import React from "react";
import makeClasses from "./styles";
import clsx from "clsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";

const RadioGroupComponent = ({ options, label, value, onChange }) => {
  const classes = makeClasses();

  const renderLabel = (label, description, icon) => (
    <div className={classes.labelWrapper}>
      <div className={classes.icon}>{icon}</div>
      <div>
        <div className={classes.label}>{label}</div>
        <div className={classes.description}>{description}</div>
      </div>
    </div>
  );

  return (
    <div>
      <FormControl component="fieldset" className={classes.container}>
        <RadioGroup aria-label={label} value={value} onChange={(e) => onChange(e.target.value)}>
          {options.map((opt) => (
            <React.Fragment key={opt.value}>
              <FormControlLabel
                value={opt.value}
                disabled={opt.disabled}
                control={<Radio />}
                label={renderLabel(opt.label, opt.description, opt.icon)}
                className={clsx(classes.input, {
                  [classes.activeInput]:
                    opt.additionalInput && value === opt.value,
                })}
              />
              {opt.additionalInput && value === opt.value && (
                <div className={classes.additionalInputContainer}>
                  <div className={classes.additionalInput}>
                    {opt.additionalInput}
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};


export default RadioGroupComponent;
